(function () {
  var lblRowEl, chartBtn, chartEl, chartTitleEl, chartBodyEl;
  var chartHandle = null;
  var chartCache = {};

  /* Which size chart belongs to this product.

     These handles and this mapping mirror templates/product.json and the
     product-type branch in sections/main-product.liquid. They are duplicated
     rather than shared because a snippet cannot carry schema settings — if
     the pages are ever renamed, both places have to change. */
  var CHART_PAGES = {
    blouse: 'size-chart-blouse',
    lehenga: 'size-chart-lehenga',
    bottom: 'size-chart-pant-skirt',
    topwear: 'size-chart-kurti-jacket-dress-shirt-top-tunic',
    all: 'size-chart-1'
  };

  var TOPWEAR = [
    'kurti', 'jacket', 'dress', 'shirt', 'top', 'tunic',
    'indian dress', 'one piece dress'
  ];

  function chartHandleFor(type) {
    var t = (type || '').trim().toLowerCase();
    if (t === 'blouse') return CHART_PAGES.blouse;
    if (t === 'lehenga') return CHART_PAGES.lehenga;
    if (t === 'pant' || t === 'skirt') return CHART_PAGES.bottom;
    if (TOPWEAR.indexOf(t) !== -1) return CHART_PAGES.topwear;
    return CHART_PAGES.all;
  }

  'use strict';

  var sheet, scrim, sizesEl, addBtn, buyBtn, titleEl, priceEl, imgEl, lblEl;
  var addonsEl, totalEl, totalValueEl;
  var basePrice = 0;
  var moneyFormat = '';
  var addons = [];
  var selectedVariant = null;
  var lastTrigger = null;
  var addLabel = 'Add to cart';
  var madeEl = null;
  var madeBase = '';

  function els() {
    sheet = document.querySelector('[data-qa-sheet]');
    if (!sheet) return false;
    scrim = document.querySelector('[data-qa-scrim]');
    sizesEl = sheet.querySelector('[data-qa-sizes]');
    addBtn = sheet.querySelector('[data-qa-add]');
    buyBtn = sheet.querySelector('[data-qa-buy]');
    titleEl = sheet.querySelector('[data-qa-title]');
    priceEl = sheet.querySelector('[data-qa-price]');
    imgEl = sheet.querySelector('[data-qa-image]');
    lblEl = sheet.querySelector('[data-qa-lbl]');
    addonsEl = sheet.querySelector('[data-qa-addons]');
    totalEl = sheet.querySelector('[data-qa-total]');
    totalValueEl = sheet.querySelector('[data-qa-total-value]');
    addLabel = addBtn.textContent.trim() || addLabel;
    madeEl = sheet.querySelector('[data-qa-made]');
    lblRowEl = sheet.querySelector('.qa-lbl-row');
    chartBtn = sheet.querySelector('[data-qa-chart-open]');
    chartEl = sheet.querySelector('[data-qa-chart]');
    chartTitleEl = sheet.querySelector('[data-qa-chart-title]');
    chartBodyEl = sheet.querySelector('[data-qa-chart-body]');
    madeBase = madeEl ? madeEl.textContent.trim() : '';
    return true;
  }

  function close(returnFocus) {
    closeChart();
    sheet.classList.remove('qa-open');
    scrim.classList.remove('qa-open');
    window.setTimeout(function () { sheet.hidden = true; }, 300);
    if (returnFocus !== false && lastTrigger) lastTrigger.focus();
  }

  function selectVariant(id, btn) {
    selectedVariant = id;
    sizesEl.querySelectorAll('.qa-size').forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
    });
    btn.setAttribute('aria-pressed', 'true');
    addBtn.disabled = false;
    if (buyBtn) buyBtn.disabled = false;
  }

  // A product with no real options has one variant Shopify titles "Default Title".
  // Showing that as a size button is nonsense — skip the picker entirely.
  function hasRealOptions(product) {
    if (product.variants.length > 1) return true;
    var only = product.variants[0];
    if (!only) return false;
    if (only.title === 'Default Title') return false;
    return !(product.options || []).every(function (o) {
      var name = typeof o === 'string' ? o : o.name;
      return name === 'Title';
    });
  }

  function renderSizes(product) {
    sizesEl.innerHTML = '';
    chartHandle = chartHandleFor(product.type);

    if (!hasRealOptions(product)) {
      // One size, so there is nothing to measure against.
      if (lblRowEl) lblRowEl.hidden = true;
      if (chartBtn) chartBtn.hidden = true;
      lblEl.hidden = true;
      sizesEl.hidden = true;
      selectedVariant = product.variants[0].id;
      addBtn.disabled = false;
      if (buyBtn) buyBtn.disabled = false;
      return;
    }

    if (lblRowEl) lblRowEl.hidden = false;
    if (chartBtn) chartBtn.hidden = false;
    lblEl.hidden = false;
    sizesEl.hidden = false;

    product.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.className = 'qa-size';
      b.type = 'button';
      b.textContent = v.title.indexOf(' - ') > -1 ? v.title.split(' - ').pop() : v.title;
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { selectVariant(v.id, b); });
      sizesEl.appendChild(b);
    });
  }


  // Prices arrive from Shopify in paise. Reuse the exact string the card
  // already rendered so formatting always matches the rest of the store.
  function formatMoney(paise) {
    // Match the store's own money string, whatever it is. The pattern must
    // start with a digit — '[\d.,]+' would otherwise match the dot in 'MRP.'
    // and inject the number into the prefix.
    var keepsDecimals = /\d[\d,]*\.\d{2}/.test(moneyFormat);
    var whole = Math.floor(paise / 100);
    var cents = paise % 100;
    var str = String(whole);
    var last3 = str.slice(-3);
    var rest = str.slice(0, -3);
    var grouped = rest
      ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3
      : last3;
    if (keepsDecimals) grouped += '.' + (cents < 10 ? '0' + cents : cents);
    return moneyFormat.replace(/\d[\d.,]*/, grouped);
  }

  function selectedAddons() {
    if (!addonsEl) return [];
    return [].slice.call(addonsEl.querySelectorAll('[data-addon]:checked')).map(function (cb) {
      var row = cb.closest('.qa-addon');
      var sel = row ? row.querySelector('select') : null;
      var id = sel ? sel.value : cb.value;
      var price = sel
        ? +sel.options[sel.selectedIndex].dataset.price
        : +cb.dataset.price;
      return { id: +id, price: price };
    });
  }

  function refreshTotal() {
    var extras = selectedAddons();
    var sum = extras.reduce(function (t, a) { return t + a.price; }, basePrice);
    if (!totalEl) return;
    if (extras.length) {
      totalEl.hidden = false;
      totalValueEl.textContent = formatMoney(sum);
    } else {
      totalEl.hidden = true;
    }
  }

  function renderAddons(raw) {
    addons = [];
    if (!addonsEl) return;
    addonsEl.innerHTML = '';
    if (!raw) { addonsEl.hidden = true; return; }
    try { addons = JSON.parse(raw); } catch (e) { addonsEl.hidden = true; return; }
    if (!addons.length) { addonsEl.hidden = true; return; }

    addonsEl.hidden = false;
    addons.forEach(function (bp, i) {
      var row = document.createElement('label');
      row.className = 'qa-addon';
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.setAttribute('data-addon', '');
      cb.value = bp.variants[0] ? bp.variants[0].id : '';
      cb.dataset.price = bp.variants[0] ? bp.variants[0].price : 0;
      cb.addEventListener('change', refreshTotal);

      var txt = document.createElement('span');
      txt.className = 'qa-addon-label';
      txt.textContent = 'Add ' + (bp.label || 'item');

      var price = document.createElement('span');
      price.className = 'qa-addon-price';
      price.textContent = bp.variants[0] ? '+ ' + formatMoney(bp.variants[0].price) : '';

      row.appendChild(cb);
      row.appendChild(txt);

      if (bp.variants.length > 1) {
        var sel = document.createElement('select');
        bp.variants.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.id;
          o.textContent = v.title;
          o.dataset.price = v.price;
          sel.appendChild(o);
        });
        sel.addEventListener('change', function () {
          price.textContent = '+ ' + formatMoney(+sel.options[sel.selectedIndex].dataset.price);
          refreshTotal();
        });
        row.appendChild(sel);
      }

      row.appendChild(price);
      addonsEl.appendChild(row);
    });
  }

  function open(trigger) {
    lastTrigger = trigger;
    sheet.hidden = false;
    titleEl.textContent = trigger.dataset.productTitle;
    priceEl.textContent = trigger.dataset.productPrice;
    imgEl.src = trigger.dataset.productImage;
    imgEl.alt = trigger.dataset.productTitle;
    moneyFormat = trigger.dataset.productPrice || '';
    basePrice = +(trigger.dataset.productPriceRaw || 0);
    renderAddons(trigger.dataset.bundles);
    refreshTotal();

    // Dispatch time is per-product data, not a blanket claim. Say nothing
    // rather than something wrong when the product has no value yet.
    if (madeEl) {
      var days = trigger.dataset.dispatchDays;
      madeEl.textContent = days
        ? madeBase + ' Dispatched in ' + days + ' days.'
        : madeBase;
    }

    closeChart();
    chartHandle = null;
    if (chartBtn) chartBtn.hidden = true;
    if (lblRowEl) lblRowEl.hidden = false;
    lblEl.hidden = false;
    sizesEl.hidden = false;
    sizesEl.innerHTML = '<span class="qa-made">Loading sizes…</span>';
    selectedVariant = null;
    addBtn.disabled = true;
    if (buyBtn) buyBtn.disabled = true;
    addBtn.textContent = addLabel;

    window.requestAnimationFrame(function () {
      sheet.classList.add('qa-open');
      scrim.classList.add('qa-open');
    });

    fetch('/products/' + trigger.dataset.productHandle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('fetch failed');
        return r.json();
      })
      .then(renderSizes)
      .catch(function () {
        sizesEl.innerHTML =
          '<span class="qa-made">Sizes could not load. Open the product page to continue.</span>';
      });
  }

  // "Add to cart" keeps the shopper on the grid, so the header count is the
  // only confirmation they get — it has to be right. Shopify returns the
  // section already unwrapped, so the bubble id sits on the wrapper rather
  // than inside it; take .shopify-section first, then fall back.
  function refreshCartBubble(sections) {
    var target = document.getElementById('cart-icon-bubble');
    if (!target || !sections || !sections['cart-icon-bubble']) return;
    var parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var fresh =
      parsed.querySelector('.shopify-section') ||
      parsed.querySelector('#cart-icon-bubble') ||
      parsed.body;
    if (fresh) target.innerHTML = fresh.innerHTML;
  }

  // Keep the drawer's own markup current even though we don't open it, so the
  // cart icon and the drawer agree the next time the shopper opens it.
  function refreshCartDrawer(sections) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !sections || typeof drawer.renderContents !== 'function') return;
    var wasActive = drawer.classList.contains('active');
    drawer.renderContents({ sections: sections });
    window.setTimeout(function () {
      if (drawer.querySelector('.cart-item')) drawer.classList.remove('is-empty');
      // renderContents opens the drawer; undo that unless it was already open.
      if (!wasActive) drawer.classList.remove('active', 'animate');
    }, 60);
  }

  function addToCart(onDone) {
    if (!selectedVariant) return;
    addBtn.disabled = true;
    if (buyBtn) buyBtn.disabled = true;
    addBtn.textContent = 'Adding…';

    var drawer = document.querySelector('cart-drawer');
    var wanted = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      : 'cart-drawer,cart-icon-bubble';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: selectedVariant, quantity: 1 }].concat(
          selectedAddons().map(function (a) { return { id: a.id, quantity: 1 }; })
        ),
        sections: wanted,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (data) {
        addBtn.disabled = false;
        if (buyBtn) buyBtn.disabled = false;
        addBtn.textContent = addLabel;
        if (typeof onDone === 'function') {
          onDone(data);
          return;
        }
        // "Add to cart" should only add — keep the shopper on the grid.
        close(false);
        refreshCartBubble(data.sections);
        refreshCartDrawer(data.sections);
      })
      .catch(function () {
        addBtn.disabled = false;
        if (buyBtn) buyBtn.disabled = false;
        addBtn.textContent = 'Could not add — try again';
      });
  }

  function closeChart() {
    if (!chartEl) return;
    chartEl.hidden = true;
    sheet.classList.remove('qa-chart-on');
  }

  function openChart() {
    if (!chartEl || !chartHandle) return;
    chartEl.hidden = false;
    sheet.classList.add('qa-chart-on');

    if (chartCache[chartHandle]) {
      chartBodyEl.innerHTML = chartCache[chartHandle];
      return;
    }

    chartBodyEl.innerHTML = '<span class="qa-made">Loading…</span>';

    // Pulled from the existing size-chart page, so whatever the merchant
    // publishes there is what the shopper sees — one chart, not two that
    // drift apart.
    fetch('/pages/' + chartHandle)
      .then(function (r) {
        if (!r.ok) throw new Error('fetch failed');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('#MainContent .rte');
        if (!content || !content.innerHTML.trim()) throw new Error('no content');

        // The pages are titled "App Size Chart - ..." — leftover from the app
        // that made them. Not worth showing a shopper.
        var heading = doc.querySelector('#MainContent h1, #MainContent h2');
        if (heading && chartTitleEl) {
          var t = heading.textContent.trim().replace(/^App\s+/i, '');
          if (t) chartTitleEl.textContent = t;
        }

        chartCache[chartHandle] = content.innerHTML;
        chartBodyEl.innerHTML = content.innerHTML;
      })
      .catch(function () {
        chartBodyEl.innerHTML =
          '<span class="qa-made">The size chart could not load. ' +
          '<a href="/pages/' + chartHandle + '">Open it in a new page</a>.</span>';
      });
  }

  function ready() {
    if (!els()) return;

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cc-quickadd]');
      if (!t) return;
      e.preventDefault();
      open(t);
    });

    scrim.addEventListener('click', function () { close(); });

    var closeBtn = sheet.querySelector('[data-qa-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { close(); });

    if (chartBtn) chartBtn.addEventListener('click', openChart);

    var chartCloseBtn = sheet.querySelector('[data-qa-chart-close]');
    if (chartCloseBtn) chartCloseBtn.addEventListener('click', closeChart);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !sheet.classList.contains('qa-open')) return;
      // The chart is the thing on top, so it is the thing Escape dismisses.
      if (chartEl && !chartEl.hidden) closeChart();
      else close();
    });

    addBtn.addEventListener('click', function () { addToCart(); });

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        buyBtn.textContent = 'Taking you to checkout…';
        addToCart(function () {
          close(false);
          // Click the theme's real checkout button rather than navigating to
          // /checkout ourselves — Razorpay Magic Checkout hooks that control,
          // and a raw navigation risks bypassing it.
          var native = document.querySelector('[name="checkout"]');
          if (native) {
            native.click();
          } else {
            window.location.href = '/checkout';
          }
          window.setTimeout(function () { buyBtn.textContent = 'Buy now'; }, 2500);
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
